import React from "react";
import { Link } from "react-router-dom";
import MetaDecorator from "../../../../utils/metaDecorator";

export default function NotFoundEN() {
  const structuredData=[{
    "@context": "http://schema.org",
    "@type": "WebPage",
    "name": "404",
    "description":"page not found !",

    "url":"https://www.metamarce.com/404",    

  }]

  const metaTagsData={
    title:'Page not found',
    description:"The page you were looking for could not be found.",
    section:"Not found",
    url:'https://www.metamarce.com/404',
    canonical:`https://www.metamarce.com/en/404`,
    img:"https://www.metamarce.com/img/404-error-with-a-cute-animal-animate-2.svg",
    type:'webpage',
    index:false
  }
  return (    
    <div>
      <MetaDecorator data={{...metaTagsData,structuredData}}/>

      <div className="container-404 text-center d-flex flex-column align-items-center ">
        <img
          className=" img-404 p-0 m-0"
          src="/img/404-error-with-a-cute-animal-animate-2.svg"
          alt="404"
        />
        <div className="mb-3 ">
          <span> The page you were looking for could not be found.</span>
          <span>
            <i className="bi bi-emoji-frown"></i>
          </span>
          <Link
            className="btn primary-btn btn-404 checkout-btn cart-footer mb-5 mt-2"
            to={`/en/demy`}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
